"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Modal_1 = require("./Modal");
exports.default = Modal_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Modal/index.js
// module id = 178
// module chunks = 8